import React from "react"

export default function Upload() {
  return (
    <symbol id="svg-upload" viewBox="0 0 32 32">
      <path
        fill="currentColor"
        d="M27.6 14.7c-.4 0-.8.3-.8.8v8c0 1.6-1.3 3-3 3H8.2c-1.6 0-3-1.3-3-3v-8c0-.4-.3-.8-.8-.8-.4 0-.8.3-.8.8v8c0 2.5 2 4.5 4.5 4.5h15.7c2.5 0 4.5-2 4.5-4.5v-8c.1-.4-.3-.8-.7-.8zm-16.8-4c.2 0 .4-.1.5-.2l3.9-3.9v14.8c0 .4.3.8.8.8.4 0 .8-.3.8-.8V6.6l3.9 3.9c.3.3.8.3 1.1 0 .3-.3.3-.7 0-1l-5.2-5.2s-.1 0-.1-.1l-.1-.1s-.1 0-.2-.1h-.4c-.1 0-.2.1-.3.2l-5.2 5.2c-.3.3-.3.8 0 1.1.1.1.3.2.5.2z"
      />
    </symbol>
  )
}
